export const enableRuntimeBranding = (brandingObj, runtimeBranding) => {
  let runtimeBrandingObj = runtimeBranding || {};
  if (runtimeBrandingObj != {} || runtimeBrandingObj != null) {
    const brandingObjKeys = Object.keys(brandingObj);
    const runtimeBrandingObjKeys = Object.keys(runtimeBrandingObj);
    brandingObjKeys.map(item => {
      return brandingObj[item] = runtimeBrandingObjKeys.includes(item) ? runtimeBrandingObj[item] : brandingObj[item];
    });
  }
  return brandingObj;
};